<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>安全设置</span></div>
			<div class="center flex-between">
				<centerLeft :menu="5"></centerLeft>
				<div class="center-right">
					<div class="title">您当前的帐号  {{user.account?user.account:user.phone}}</div>
					
					<div class="item flex-between flex-center">
						<img src="@/assets/images/me/pwd.png"/>
						<div class="item-text">
							<div>登录密码</div>
							<div>建议您定期更换密码，设置安全性高的密码可以使帐号更安全</div>
						</div>
						<router-link to="/updatepwd" class="item-button">修改</router-link>
					</div>
					
					
					<div class="item flex-between flex-center">
						<img src="@/assets/images/me/phone.png"/>
						<div class="item-text">
							<div>安全手机  {{user.phone.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2')}}</div>
							<div>安全手机可以用于登录帐号，重置密码或其他安全验证</div>
						</div>
						<router-link to="/updatephone" class="item-button">更换</router-link>
					</div>
					
					
					<div class="notice flex-start flex-center">
						<img src="@/assets/images/me/cross.png"/>
						<div class="notice-text">
							<div>安全服务提示</div>
							<div>·确认您登录的是朵小喵网址，注意防范进入钓鱼网站，不要轻信各种即时通讯工具发送的商品或支付链接，谨防网购诈骗</div>
							<div>·建议您安装杀毒软件，并定期更新操作系统等软件补丁，确保帐号及交易安全</div>
						</div>
					</div>
					
					
					
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
export default {
	name: 'index',
	components:{
		centerLeft
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	data(){
		return {
		}
	},
	mounted() {
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	.notice{
		width: 100%;
		background: #F8F8F8;
		padding: 30px;
		box-sizing: border-box;
		img{
			width: 40px;
			height: 40px;
			flex: 0 0 40px;
			margin-right: 20px;
		}
		.notice-text{
			opacity: 0.6;
			font-size: 16px;
			line-height: 24px;
			color: #070B13;
		}
	}
	.item{
		width: 100%;
		height: 122px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		padding: 0px 60px;
		box-sizing: border-box;
		margin-bottom: 20px;
		img{
			width: 48px;
			height: 48px;
			flex: 0 0 48px;
			margin-right: 67px;
		}
		.item-text{
			width: 100%;
			div{
				&:first-of-type{
					font-size: 20px;
					font-weight: 500;
					line-height: 28px;
					color: #070B13;
				}
				&:last-of-type{
					font-size: 16px;
					color: rgba(7, 11, 19, 0.6);
					margin-top: 12px;
				}
			}
		}
		.item-button{
			width: 108px;
			height: 36px;
			border: 1px solid #E91A12;
			font-size: 14px;
			line-height: 36px;
			color: rgba(7, 11, 19, 1);
			text-align: center;
			cursor: pointer;
		}
	}
	.title{
		font-size: 16px;
		font-weight: 500;
		line-height: 64px;
		color: #070B13;
	
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
